import { render, staticRenderFns } from "./page-meta-apartment.vue?vue&type=template&id=316ce44e&scoped=true&"
import script from "./page-meta-apartment.ts?vue&type=script&lang=ts&"
export * from "./page-meta-apartment.ts?vue&type=script&lang=ts&"
import style0 from "./page-meta-apartment.scss?vue&type=style&index=0&id=316ce44e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "316ce44e",
  null
  
)

export default component.exports